/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Ai_Chat_Chart_GroupedInputs */

const en_admin_ai_chat_chart_grouped = /** @type {(inputs: Admin_Ai_Chat_Chart_GroupedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grouped`)
};

const de_admin_ai_chat_chart_grouped = /** @type {(inputs: Admin_Ai_Chat_Chart_GroupedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gruppiert`)
};

const es_admin_ai_chat_chart_grouped = /** @type {(inputs: Admin_Ai_Chat_Chart_GroupedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agrupado`)
};

const fr_admin_ai_chat_chart_grouped = /** @type {(inputs: Admin_Ai_Chat_Chart_GroupedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Groupé`)
};

const nl_admin_ai_chat_chart_grouped = /** @type {(inputs: Admin_Ai_Chat_Chart_GroupedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gegroepeerd`)
};

/** @type {(inputs: Admin_Ai_Chat_Chart_GroupedInputs) => LocalizedString} */
const it_admin_ai_chat_chart_grouped = en_admin_ai_chat_chart_grouped;

/** @type {(inputs: Admin_Ai_Chat_Chart_GroupedInputs) => LocalizedString} */
const pt_br2_admin_ai_chat_chart_grouped = en_admin_ai_chat_chart_grouped;

/** @type {(inputs: Admin_Ai_Chat_Chart_GroupedInputs) => LocalizedString} */
const pl_admin_ai_chat_chart_grouped = en_admin_ai_chat_chart_grouped;

/** @type {(inputs: Admin_Ai_Chat_Chart_GroupedInputs) => LocalizedString} */
const hu_admin_ai_chat_chart_grouped = en_admin_ai_chat_chart_grouped;

/** @type {(inputs: Admin_Ai_Chat_Chart_GroupedInputs) => LocalizedString} */
const ro_admin_ai_chat_chart_grouped = en_admin_ai_chat_chart_grouped;

/**
* | output |
* | --- |
* | "Grouped" |
*
* @param {Admin_Ai_Chat_Chart_GroupedInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_ai_chat_chart_grouped = /** @type {((inputs?: Admin_Ai_Chat_Chart_GroupedInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Ai_Chat_Chart_GroupedInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_ai_chat_chart_grouped(inputs)
	if (locale === "de") return de_admin_ai_chat_chart_grouped(inputs)
	if (locale === "es") return es_admin_ai_chat_chart_grouped(inputs)
	if (locale === "fr") return fr_admin_ai_chat_chart_grouped(inputs)
	if (locale === "nl") return nl_admin_ai_chat_chart_grouped(inputs)
	if (locale === "it") return it_admin_ai_chat_chart_grouped(inputs)
	if (locale === "pt-BR") return pt_br2_admin_ai_chat_chart_grouped(inputs)
	if (locale === "pl") return pl_admin_ai_chat_chart_grouped(inputs)
	if (locale === "hu") return hu_admin_ai_chat_chart_grouped(inputs)
	return ro_admin_ai_chat_chart_grouped(inputs)
});
export { admin_ai_chat_chart_grouped as "admin.ai_chat.chart_grouped" }